import {RcFile} from 'antd/lib/upload';

import {deserializeV2, fetchAndDeserialize, serialize} from '../../util/api-adapter';
import {FetchMethodEnum, fetchNoContent, fetchX} from '../../util/fetch';
import {getCsrfHeaders, mainApiHeaders, rootApiUrl} from '../api/api-const';
import {buildPublicationListQuery} from '../publication/publication-filter-helper';
import {PublicationListFilterType} from '../publication/publication-filter-type';

import {
    CommonPromotionStatusEnum,
    promotionDetailSchema,
    PromotionDetailType,
    PromotionRequestType,
    promotionSelectedCompaniesSchema,
    PromotionSelectedCompaniesType,
    promotionsListResponseSchema,
    PromotionsListResponseType,
    uploadPromotionImageResponseSchema,
    UploadPromotionImageResponseType,
} from './promotions-type';

export async function fetchPromotions(
    page: number | null,
    filter?: PublicationListFilterType
): Promise<PromotionsListResponseType> {
    return fetchAndDeserialize<PromotionsListResponseType>(
        `/cp/promotions/?${buildPublicationListQuery(page, filter)}`,
        promotionsListResponseSchema
    );
}

export async function fetchPromotionById(promotionId: number): Promise<PromotionDetailType> {
    return fetchAndDeserialize<PromotionDetailType>(`/cp/promotions/${promotionId}/`, promotionDetailSchema);
}

export async function fetchPromotionSelectedCompanies(
    promotionId: number,
    page: number | null
): Promise<PromotionSelectedCompaniesType> {
    return fetchAndDeserialize<PromotionSelectedCompaniesType>(
        `/cp/promotions/${promotionId}/companies_details/?page=${page}`,
        promotionSelectedCompaniesSchema
    );
}

export function createPromotion(data: PromotionRequestType): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/promotions/create/`, {
        method: FetchMethodEnum.post,
        body: JSON.stringify(serialize(data)),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function updatePromotion(promotionId: number, data: PromotionRequestType): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/promotions/${promotionId}/`, {
        method: FetchMethodEnum.put,
        body: JSON.stringify(serialize(data)),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function changePromotionStatus(
    promotionId: number,
    status: CommonPromotionStatusEnum.Paused | CommonPromotionStatusEnum.Sent
): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/promotions/${promotionId}/status/`, {
        method: FetchMethodEnum.patch,
        body: JSON.stringify(serialize({status})),
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export function deletePromotion(promotionId: number): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/promotions/${promotionId}/delete/`, {
        method: FetchMethodEnum.delete,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}

export async function uploadPromotionImage(file: RcFile): Promise<UploadPromotionImageResponseType> {
    const url = `${rootApiUrl}/cp/promotions/images/`;

    const formData = new FormData();

    formData.append('image', file);

    const response = await fetchX(url, {
        method: FetchMethodEnum.post,
        headers: {...getCsrfHeaders()},
        body: formData,
    });

    return deserializeV2<UploadPromotionImageResponseType>(url, uploadPromotionImageResponseSchema, response);
}

export function deletePromotionImage(imageId: number): Promise<void> {
    return fetchNoContent(`${rootApiUrl}/cp/promotions/images/${imageId}/`, {
        method: FetchMethodEnum.delete,
        headers: {...mainApiHeaders, ...getCsrfHeaders()},
    });
}
